/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Days_TailInputs */

const en_for_whom_days_tail = /** @type {(inputs: For_Whom_Days_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The app knows.`)
};

const pl_for_whom_days_tail = /** @type {(inputs: For_Whom_Days_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikacja to wie.`)
};

/**
* | output |
* | --- |
* | "The app knows." |
*
* @param {For_Whom_Days_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_days_tail = /** @type {((inputs?: For_Whom_Days_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Days_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_days_tail(inputs)
	return en_for_whom_days_tail(inputs)
});